module.exports = __webpack_public_path__ + "static/media/ovologo.989cb5b8.jpg";